import * as React from 'react';
import {FunctionComponent} from 'react';
import {Share} from '../../Components/Workout/Generic/Share';
import {OutdoorFullWorkout} from '../../../Models/FullWorkout';
import {FullWorkoutSummary} from '../../Components/Workout/FullWorkoutSummary';
import {Feedback} from '../../Components/Feedback';
import {Me} from '../../../Models/Me';
import {Csrf} from '../../Components/Form/Csrf';
import {NetworkResult} from '../../../Network/NetworkResult';
import {GeoTrack} from '../../../Models/GeoTrack';
import {NetworkRequestStatusView} from '../../Components/Utils/NetworkRequestStatusView';
import {Loader} from '../../Components/Utils/Loader';
import {GeoTrackAnalyzer} from '../../Components/Workout/Outdoor/GeoTrackAnalyzer';
import {FeatureFlags} from '../../../FeatureFlags';
import {GeoTrackMap} from '../../Components/Workout/Outdoor/GeoTrackMap';
import {OutdoorIntervalTable} from '../../Components/Workout/Outdoor/OutdoorIntervalTable';
import {geoTrackToIntervals} from '../../../Geo/geoTrackToIntervals';
import {OutdoorsGraphs} from '../../Components/Charts/OutdoorsGraphs';
import {Link} from 'react-router-dom';
import {UploadToStrava} from '../../Components/Workout/Generic/UploadtoStrava';
import {HeartRateTrack} from '../../../Models/HeartRateTrack';
import {OutdoorWorkoutExport} from '../../Components/Workout/Outdoor/OutdoorWorkoutExport';
import {EditTitleForm} from '../../Components/Workout/Generic/EditTitleForm';
import {OutdoorIntervalTablePromo} from '../../Components/Workout/Outdoor/OutdoorIntervalTablePromo';
import {OutdoorGraphsPromo} from '../../Components/Charts/OutdoorGraphsPromo';
import {GeoTrackStrokes} from '../../../Models/GeoTrackStrokes';

interface OwnProps {
    title: string;
    me: Me;
    outdoorFullWorkout: OutdoorFullWorkout;
    tracksDownloadResult: NetworkResult<{
        geo: GeoTrack;
        geoStrokes: GeoTrackStrokes | null;
        heartRate: HeartRateTrack | null;
    }>;
}

export const OutdoorFull: FunctionComponent<OwnProps> = ({title, me, outdoorFullWorkout, tracksDownloadResult}) => {
    return (
        <div className="container">
            <div className="row">
                <div className="col-12 d-flex flex-row justify-content-start">
                    <Link to="/workouts" className="btn btn-back-arrow">
                        <i className="bi bi-arrow-left"></i>
                    </Link>
                    {me.id === outdoorFullWorkout.user_id && <EditTitleForm id={outdoorFullWorkout.id} title={title} />}
                    {me.id !== outdoorFullWorkout.user_id && (
                        <h1>
                            {title} by {outdoorFullWorkout.public_user.display_name || 'unnamed'}
                        </h1>
                    )}
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-lg-9">
                    <FullWorkoutSummary fullWorkout={outdoorFullWorkout} />
                    <NetworkRequestStatusView
                        result={tracksDownloadResult}
                        loader={() => <Loader className="mt-3" />}
                        error={() => null}
                        component={(tracks) => {
                            const intervalList = geoTrackToIntervals(tracks.geo);
                            return (
                                <>
                                    {FeatureFlags.geoTrackAnalyzer ? (
                                        <GeoTrackAnalyzer intervals={intervalList} />
                                    ) : (
                                        <GeoTrackMap height={400} geoTrack={tracks.geo} />
                                    )}
                                    {FeatureFlags.outdoorIntervals ? (
                                        <OutdoorIntervalTable intervals={intervalList} />
                                    ) : (
                                        FeatureFlags.isAdvancedSubscriptionsEnabled && <OutdoorIntervalTablePromo />
                                    )}
                                    {FeatureFlags.outdoorGraphs ? (
                                        <OutdoorsGraphs
                                            geoTrack={tracks.geo}
                                            geoTrackStrokes={tracks.geoStrokes}
                                            heartRateTrack={tracks.heartRate}
                                        />
                                    ) : (
                                        FeatureFlags.isAdvancedSubscriptionsEnabled && <OutdoorGraphsPromo />
                                    )}
                                </>
                            );
                        }}
                    />
                </div>
                <div className="col-12 col-lg-3">
                    <OutdoorWorkoutExport className="mb-3 mt-lg-0 mt-3" outdoorPartialWorkout={outdoorFullWorkout} />
                    <Share className="mb-3 mt-lg-0 mt-3" partialWorkout={outdoorFullWorkout} />
                    <UploadToStrava className="mb-3" me={me} fullWorkout={outdoorFullWorkout} />
                    <Feedback className="mb-3" />
                    <div className="row mb-3">
                        <div className="col-12 text-center">
                            <form
                                action={`/workout/${outdoorFullWorkout.id}/delete`}
                                method="post"
                                onSubmit={(e) => {
                                    if (!confirm('Are you sure you want to delete this workout?')) {
                                        e.preventDefault();
                                        return false;
                                    }
                                }}
                            >
                                <Csrf />
                                <button className="btn">
                                    <i className="bi-trash me-2" />
                                    Delete workout
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
